module.exports = __webpack_public_path__ + "static/images/wzsc-logo.7204dd3.png";